var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 100,
    viewBox: "0 0 71 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 47.5C32.1848 47.5 29.0054 46.183 26.6612 43.8388C24.317 41.4946 23 38.3152 23 35C23 31.6848 24.317 28.5054 26.6612 26.1612C29.0054 23.817 32.1848 22.5 35.5 22.5C38.8152 22.5 41.9946 23.817 44.3388 26.1612C46.683 28.5054 48 31.6848 48 35C48 36.6415 47.6767 38.267 47.0485 39.7835C46.4203 41.3001 45.4996 42.6781 44.3388 43.8388C43.1781 44.9996 41.8001 45.9203 40.2835 46.5485C38.767 47.1767 37.1415 47.5 35.5 47.5ZM35.5 0C26.2174 0 17.315 3.68749 10.7513 10.2513C4.18749 16.815 0.5 25.7174 0.5 35C0.5 61.25 35.5 100 35.5 100C35.5 100 70.5 61.25 70.5 35C70.5 25.7174 66.8125 16.815 60.2487 10.2513C53.685 3.68749 44.7826 0 35.5 0Z",
    fill: "#3DAFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7bb4f4d500b65544f692bd65cb31aca9.svg";
export { ForwardRef as ReactComponent };